<template>
  <v-app class="bg-color">
    <v-main>
      <v-container fluid grid-list-xs pt-5>
        <v-layout row wrap justify-center align-center>
          <v-flex xs11 lg11>
            <h2>{{ $t("Toolbar.logosetting") }}</h2>
          </v-flex>
        </v-layout>

        <v-layout row wrap justify-center align-center pt-5>
          <v-flex xs11 sm11 md11 lg11>
            <v-card class="pa-2 rounded-lg">
              <v-card-title primary-title class="pa-2">
                {{ $t("Toolbar.logosetting") }}
              </v-card-title>
              <v-layout row wrap justify-center align-center>
                <v-flex xs11 lg11>
                  <div id="app">
                    <div v-if="!file">
                      <div
                        :class="['dropZone', dragging ? 'dropZone-over' : '']"
                        @dragenter="dragging = true"
                        @dragleave="dragging = false"
                      >
                        <div class="dropZone-info" @drag="onChange">
                          <div>
                            <span class="dropZone-title">
                              <v-avatar
                                v-if="ImageData.length > 0"
                                style="
                                  border-style: dashed;
                                  border-radius: 0.5rem;
                                  border-width: 0.3rem;
                                "
                                class="profile"
                                color="grey"
                                size="200"
                                tile
                              >
                                <v-img
                                  style="background-size: contain !important"
                                  :src="
                                    'data:' + FileType + ';base64,' + ImageData
                                  "
                                ></v-img>
                              </v-avatar>
                              <v-avatar
                                tile
                                v-else
                                size="200"
                                color="#077893"
                                class="mr-2"
                              >
                                <v-icon size="180" color="white"
                                  >mdi-account-settings-outline</v-icon
                                >
                              </v-avatar>
                            </span>
                          </div>
                          <br />
                          <span class="dropZone-title"
                            ><h1>คลิกเพื่ออัปโหลดรูปภาพ</h1></span
                          >
                          <div class="dropZone-upload-limit-info red--text">
                            <br />
                            <div>* กรุณาเลือกรูปภาพไม่เกิน 50 KB</div>
                          </div>
                        </div>
                        <input type="file" @change="onChange" />
                      </div>
                    </div>
                    <div v-else>
                      <div
                        :class="['dropZone', dragging ? 'dropZone-over' : '']"
                        @dragenter="dragging = true"
                        @dragleave="dragging = false"
                      >
                        <div class="dropZone-info" @drag="onChange">
                          <div>
                            <span class="dropZone-title">
                              <v-avatar
                                style="
                                  border-style: dashed;
                                  border-radius: 0.5rem;
                                  border-width: 0.3rem;
                                "
                                class="profile"
                                color="grey"
                                size="200"
                                tile
                              >
                                <v-img
                                  style="background-size: contain !important"
                                  :src="imageURL"
                                  alt="Uploaded Image"
                                ></v-img>
                              </v-avatar>
                              <!-- <v-img
                              style="background-size: contain !important"
                              :src="imageURL"
                              alt="Uploaded Image"
                            /> -->
                            </span>
                          </div>
                          <br />
                          <span class="dropZone-title"
                            ><h1>คลิกเพื่ออัปโหลดรูปภาพ</h1></span
                          >
                          <div class="dropZone-upload-limit-info red--text">
                            <br />
                            <div>* กรุณาเลือกรูปภาพไม่เกิน 50 KB</div>
                          </div>
                        </div>
                        <input type="file" @change="onChange" />
                      </div>
                    </div>

                    <div class="uploadedFile-info">
                      <br />
                      <div class="red--text">
                        <b> {{ $t("Profile.NoteLogo") }}</b>
                      </div>
                      <div>
                        <v-container>
                          <v-layout row wrap justify-center align-ccenter>
                            <v-flex xs5 lg3>
                              <v-btn
                                block
                                outlined
                                color="red"
                                :dark="FileUpload.length !== 0"
                                :disabled="FileUpload.length == 0"
                                @click="removeFile"
                              >
                                {{ $t("consentlist.cancleBtn") }}
                              </v-btn>
                            </v-flex>
                            <v-flex xs5 lg3>
                              <v-btn
                                block
                                color="#077893"
                                :dark="FileUpload.length !== 0"
                                :disabled="FileUpload.length == 0"
                                @click="Fn_Save"
                                :loading="btnSave"
                              >
                                {{ $t("policyForm.save") }}
                              </v-btn>
                            </v-flex>
                          </v-layout>
                        </v-container>
                      </div>
                      <!-- <div>fileName: {{ file.name }}</div>
                    <div>fileZise(bytes): {{ file.size }}</div>
                    <div>extension：{{ extension }}</div> -->
                    </div>
                  </div>
                </v-flex>
              </v-layout>
            </v-card>
          </v-flex>
        </v-layout>
        <div v-if="loadingDownloadData">
          <OverlaySearch />
        </div>
      </v-container>
    </v-main>
  </v-app>
</template>

<script>
import OverlaySearch from "@/components/layouts/LoadingPage.vue";
import authorization from "@/functions/authorization.js";
import Swal2 from "sweetalert2/dist/sweetalert2.js";
import { mapGetters } from "vuex";

const Toast = Swal2.mixin({
  toast: true,
  position: "top-end",
  showConfirmButton: false,
  timer: 3000,
});

export default {
  components: { OverlaySearch },
  data() {
    return {
      file: "",
      dragging: false,
      loadingDownloadData: false,
      FileType: "",
      ImageData: "",
      FileUpload: [],
      btnSave: false,
      imageURL: "",
    };
  },

  mounted() {
    this.Fn_GetDataLogo();
  },

  methods: {
    onChange(e) {
      var files = e.target.files || e.dataTransfer.files;

      if (!files.length) {
        this.dragging = false;
        return;
      }

      this.createFile(files[0]);
    },
    createFile(file) {
      if (!file.type.match("image/*")) {
        Toast.fire({
          icon: "error",
          title: "กรุณาเลือกไฟล์รูปภาพ (jpg, jpeg, PNG, gif, bmp)",
        });
        this.dragging = false;
        return;
      }
      if (file.size > 50000) {
        Toast.fire({
          icon: "error",
          title: "กรุณาตรวจสอบขนาดไฟล์ไม่เกิน 50 KB",
        });
        this.dragging = false;
        return;
      }

      this.file = file;
      this.FileUpload = this.file;
      this.imageURL = URL.createObjectURL(this.FileUpload);

      this.dragging = false;
    },
    removeFile() {
      this.file = "";
      this.FileUpload = "";
      Toast.fire({
        icon: "success",
        title: "ยกเลิกสำเร็จ",
      });
    },
    async Fn_GetDataLogo() {
      this.loadingDownloadData = true;
      if (this.$cookies.get("BusinessId") != "00000") {
        // this.loadingDownloadData = true
        const payload = {
          BusinessId: this.$cookies.get("BusinessId"),
        };
        var Headers = {
          AccountId: this.$cookies.get("OneAccountId"),
        };
        var dataEncode = await authorization.encodeDataNew(payload);
        var auth = await authorization.encodeDataNew(Headers);
        var headers = { Authorization: "Bearer " + auth };
        this.axios
          .post(
            process.env.VUE_APP_API_FACTORING_SERVICE +
              "business/GetLogoBusiness",
            { Data: dataEncode },
            { headers }
          )
          .then((response) => {
            this.loadingDownloadData = false;
            if (response.data.Status === "OK") {
              this.ImageData = response.data.Message.ImageBase64;
              this.FileType = response.data.Message.FileType;
            } else {
              Toast.fire({
                icon: "error",
                title: response.data.ErrorMessage,
              });
            }
          })
          .catch((error) => {
            this.loadingDownloadData = false;
            if (error.response) {
              Toast.fire({
                icon: "error",
                title: error.response.data.ErrorMessage,
              });
            } else if (error.request) {
              Toast.fire({
                icon: "error",
                title: error.request,
              });
            } else {
              Toast.fire({
                icon: "error",
                title: error.message || error,
              });
            }
          });
      }
    },
    Fn_Save() {
      this.btnSave = true;
      const bodyFormData = new FormData();
      bodyFormData.append("BusinessId", this.$cookies.get("BusinessId"));
      bodyFormData.append("AccountId", this.$cookies.get("OneAccountId"));
      bodyFormData.append("FileLogo", this.FileUpload);

      this.axios
        .post(
          process.env.VUE_APP_API_FACTORING_SERVICE +
            "business/UpdateLogoBusiness",
          bodyFormData
        )
        .then((response) => {
          this.btnSave = false;

          if (response.data.Status === "OK") {
            Toast.fire({
              icon: "success",
              title: this.$i18n.t("alert.imgupload"),
            });
            this.FileUpload = [];
            this.Fn_GetDataLogo();
          } else {
            Toast.fire({
              icon: "error",
              title: response.data.ErrorMessage,
            });
          }
        })
        .catch((error) => {
          this.btnSave = false;
          if (error.response) {
            Toast.fire({
              icon: "error",
              title: error.response.data.ErrorMessage,
            });
          } else if (error.request) {
            Toast.fire({
              icon: "error",
              title: error.request,
            });
          } else {
            Toast.fire({
              icon: "error",
              title: error.message || error,
            });
          }
        });
    },
  },
  computed: {
    ...mapGetters(["Profile"]),
    ...mapGetters(["Business"]),
    ...mapGetters(["DataAllRole"]),
    ...mapGetters(["DataAccount"]),

    extension() {
      return this.file ? this.file.name.split(".").pop() : "";
    },
    _SelectAccountId: {
      get() {
        return this.Business.BusinessId || "-";
      },
    },
  },
  watch: {
    _SelectAccountId(val) {
      this.Fn_GetDataLogo();
    },
  },
};
</script>

<style scoped>
.bg-color {
  background-color: #ddf7ff;
}
.dropZone {
  width: 100%;
  height: 500px;
  position: relative;
  border: 2px dashed #eee;
  transition: 0.3s;
  border-radius: 0.5rem;
}

.dropZone:hover {
  border: 2px dashed #077893;
  opacity: 1;
  border-radius: 0.5rem;
  background-color: #00000021;
}

.dropZone:hover,
.dropZone-title:hover {
  color: #077893;
}

.dropZone-info {
  color: #a8a8a8;
  position: absolute;
  top: 50%;
  width: 100%;
  transform: translate(0, -50%);
  text-align: center;
}

.dropZone-title {
  color: #077893;
}

.dropZone input {
  position: absolute;
  cursor: pointer;
  top: 0px;
  right: 0;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 100%;
  opacity: 0;
}

.dropZone-upload-limit-info {
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
}

.dropZone-over {
  background: #5c5c5c;
  opacity: 0.8;
}
</style>
